<template>
  <form
    method="GET"
    class="search-bar-wrapper"
  >
    <div class="search-bar">
      <div class="search-input-container">
        <input
          ref="searchInput"
          v-model="searchInputValue"
          aria-label="Search by name"
          type="search"
          class="search-input"
          :class="isActive ? 'is-open' : 'is-closed'"
          :placeholder="searchPlaceholder"
          value="@searchQuery"
        >
        <button
          aria-label="click to search"
          class="btn-search"
          @click.prevent="toggleSearch"
        >
          <Search
            class="icon"
          />
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Utils from '@/lib/utils';

export default {
  name: 'SearchBar',
  components: {
    Search: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Search.vue'),
  },
  props: {
    searchAction: {
      type: String,
      default: null,
    },
    searchPlaceholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
      searchInputValue: '',
    };
  },
  methods: {
    focusInput() {
      this.$refs.searchInput.focus();
    },
    toggleSearch() {
      if (this.searchInputValue === '') {
        this.isActive = !this.isActive;
        this.focusInput();
      } else {
        let newUrl = Utils.queryString.update('q', this.searchInputValue, this.searchAction);
        window.location = newUrl;
      }
    },
  },
};
</script>

<style lang="postcss">
.search-bar {
  @apply justify-end w-full;
  .theme-secondary & {
    .icon {
    color: white;
  }

}
  &-wrapper {
    @apply w-full hidden;
    height: 36px;

    @screen lg {
      @apply flex mt-5;
    }
  }

  .icon {
    width: 16px;
    height: 16px;
    color: black;
  }

  @screen md {
    @apply relative mb-0;
    height: 34px;
  }

  .search-input-container {
    @apply flex rounded border-0 px-4 py-1 items-center text-sm shadow-md bg-white w-full;

    @screen md {
      @apply absolute right-0 z-10 w-auto;
      bottom: 10px;
    }
    .theme-secondary & {
      @apply flex rounded border-0 px-4 py-1 items-center text-sm shadow-md bg-secondary-bravo w-full;

      @screen md {
      @apply absolute right-0 z-10 w-auto;
      bottom: 10px;
    }
    }
    .search-input {
      --search-iput-width: 275px;
      @apply py-1 w-full;
      transition: min-width 150ms ease, max-width 150ms ease;

      &:focus-visible {
        box-shadow: none;
      }

      &.is-open {
        @apply mr-2;
        max-width: none;

        @screen md {
          min-width: var(--search-iput-width);
          max-width: var(--search-iput-width);
        }
      }

      &.is-closed {
        overflow: hidden;
        max-width: none;

        @screen md {
          max-width: 0;
          min-width: 0;
        }
      }
    }
  }
}
</style>
